import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

// Layouts
import MainLayout from '@/components/layouts/MainLayout';

// Pages
import LoginPage from '@/pages/auth/LoginPage';
import DashboardPage from '@/pages/dashboard/DashboardPage';
import ClientsPage from '@/pages/clients/ClientsPage';
import ClientDetailPage from '@/pages/clients/ClientDetailPage';
import ClientCreatePage from '@/pages/clients/ClientCreatePage';
import StaffPage from '@/pages/staff/StaffPage';
import StaffCreatePage from '@/pages/staff/StaffCreatePage';
import AttendancePage from '@/pages/attendance/AttendancePage';
import ServiceRecordsPage from '@/pages/records/ServiceRecordsPage';
import SupportPlansPage from '@/pages/support-plans/SupportPlansPage';
import InvoicesPage from '@/pages/invoices/InvoicesPage';
import SettingsPage from '@/pages/settings/SettingsPage';

// Protected Route
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="clients" element={<ClientsPage />} />
        <Route path="clients/new" element={<ClientCreatePage />} />
        <Route path="clients/:id" element={<ClientDetailPage />} />
        <Route path="staff" element={<StaffPage />} />
        <Route path="staff/new" element={<StaffCreatePage />} />
        <Route path="attendance" element={<AttendancePage />} />
        <Route path="records" element={<ServiceRecordsPage />} />
        <Route path="support-plans" element={<SupportPlansPage />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;

